<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Cómo tomar la foto</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-text-center">

  <div *ngIf="isLoading" class="image-loader">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Cargando imagen...</p>
  </div>

  <ion-img
    [src]="tutorialImg || 'assets/img/how-to.webp'"
    (ionImgWillLoad)="onImageLoadStart()"
    (ionImgDidLoad)="onImageLoaded()"
    (ionError)="onImageError()">
  </ion-img>

  <ion-item lines="none">
    <ion-checkbox [formControl]="doNotShowAgain">No volver a mostrar</ion-checkbox>
  </ion-item>

  <ion-button class="ion-margin-bottom" (click)="close()">Continuar</ion-button>

</ion-content>

